import * as React from 'react';
import { useRef } from 'react';
import { Typography, List, CircularProgress, Button } from '@mui/material';
import { Box, Paper, Divider } from '@mui/material';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import FeedIcon from '@mui/icons-material/Feed';
import DocumentationSelect from '../modals/DocumentationSelect';
import VitalsListItems from './VitalsListItems';
import TransactionsListItems from './TransactionsListItems';
import AppointmentsListItems from './AppointmentsListItems';
import PrescriptionsListItems from './PrescriptionsListItems';
import InvoicesListItems from './InvoicesListItems';
import WaiversListItems from './WaiversListItems';

export default function DocumentationList({ history = null, historyEntry = null, pet = null, fetchData = null }) {
  const { t } = useTranslation('common');
  const { showSnackbar } = useSnackbar();

  const [listEmpty, setListEmpty] = React.useState(true);

  const [doneLoadingAppointments, setDoneLoadingAppointments] = React.useState(false);
  const [doneLoadingPrescriptions, setDoneLoadingPrescriptions] = React.useState(false);
  const [doneLoadingVitals, setDoneLoadingVitals] = React.useState(false);
  const [doneLoadingTransactions, setDoneLoadingTransactions] = React.useState(false);
  const [doneLoadingAll, setDoneLoadingAll] = React.useState(false);

  const vitalsRef = useRef();
  const shoppingCartRef = useRef();
  const appointmentRef = useRef();
  const prescriptionRef = useRef();
  const invoiceRef = useRef();
  const waiverRef = useRef();

  const [documentationSelectOpen, setDocumentationSelectOpen] = React.useState(false);
  const onDocumentationSelect = (selected) => {
    switch (selected) {
      case "vitals":
        vitalsRef.current?.handleVitalsCreate();
        break;
      case "inventory":
        shoppingCartRef.current?.handleShoppingCartOpen();
        break;
      case "appointment":
        appointmentRef.current?.handleAppointmentCreate();
        break;
      case "prescription":
        prescriptionRef.current?.handleCreate();
        break;
      case "invoice":
        invoiceRef.current?.handleInvoiceCreate();
        break;
      case "waiver":
        waiverRef.current?.handleWaiverCreate();
        break;
      default:
        
    }
    setDocumentationSelectOpen(false);
  };

  React.useEffect(() => {
    if (doneLoadingAppointments && doneLoadingPrescriptions && doneLoadingVitals && doneLoadingTransactions)
    {
      setDoneLoadingAll(true);
    }
  }, [doneLoadingAppointments, doneLoadingPrescriptions, doneLoadingVitals, doneLoadingTransactions]);
  
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 2, 
        borderRadius: 2, 
        // bgcolor: 'background.default' 
      }}
    >
      <Typography variant="h6" >
        Documentation
      </Typography>
      {doneLoadingAll && listEmpty ? 
        <Divider variant="fullWidth" component="li">
          <Typography variant="caption" color="text.secondary">
            no documentation
          </Typography>
        </Divider>
      : null}
      <List sx={{ mb: 1, width: '100%', bgcolor: 'background.paper' }}>
        <InvoicesListItems
          setListEmpty={setListEmpty}
          setDoneLoading={setDoneLoadingAppointments}
          ref={invoiceRef}
          history={history}
          historyEntry={historyEntry}
          pet={pet}
        />
        <AppointmentsListItems
          setListEmpty={setListEmpty}
          setDoneLoading={setDoneLoadingAppointments}
          ref={appointmentRef}
          history={history}
          historyEntry={historyEntry}
          pet={pet}
        />
        <PrescriptionsListItems
          setListEmpty={setListEmpty}
          setDoneLoading={setDoneLoadingPrescriptions}
          ref={prescriptionRef}
          history={history}
          historyEntry={historyEntry}
          pet={pet}
        />
        <VitalsListItems
          fetchData={fetchData}
          setListEmpty={setListEmpty}
          setDoneLoading={setDoneLoadingVitals}
          ref={vitalsRef}
          history={history}
          historyEntry={historyEntry}
          pet={pet}
        />
        <TransactionsListItems 
          ref={shoppingCartRef}
          setListEmpty={setListEmpty}
          setDoneLoading={setDoneLoadingTransactions}
          history={history}
          historyEntry={historyEntry}
          pet={pet}
        />
        <WaiversListItems 
          setListEmpty={setListEmpty}
          setDoneLoading={setDoneLoadingVitals}
          ref={waiverRef}
          history={history}
          historyEntry={historyEntry}
          pet={pet}
        />
      </List>
      {!doneLoadingAll ? 
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
          <CircularProgress size={24} />
        </Box>
      : null}
      <Button 
        variant='outlined' 
        fullWidth 
        onClick={() => setDocumentationSelectOpen(true)}
        startIcon={<FeedIcon />}
      >
        Add Documentation
      </Button>
      <DocumentationSelect 
        open={documentationSelectOpen}
        onClose={() => {
          setDocumentationSelectOpen(false);
        }}
        onSelect={onDocumentationSelect}
      />
    </Paper>
  );
}